export default {
  dgh: {
    singleProjectHeader: {
      singleProjectTitle: 'David Geffen Hall',
      singleProjectDate: '2022',
      singleProjectTag: 'Installation + Web Application',
    },
    projectImages: [
      {
        id: 1,
        title: '',
        img: require('@/assets/images/dgh_1.jpg'),
      },
      {
        id: 3,
        title: '',
        img: require('@/assets/images/dgh_5.jpeg'),
      },
      {
        id: 2,
        title: '',
        img: require('@/assets/images/dgh_2.jpg'),
      },
      {
        id: 3,
        title: '',
        img: require('@/assets/images/dgh_4.jpg'),
      },
      {
        id: 4,
        title: '',
        img: require('@/assets/videos/dgh_3.mp4'),
      },
    ],
    projectInfo: {
      clientHeading: 'About Client',
      companyInfos: [
        {
          id: 1,
          title: 'Name',
          details: 'Lincoln Center',
        },
        {
          id: 2,
          title: 'Services',
          details: 'Performing Arts',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://www.lincolncenter.org/',
        },
        {
          id: 4,
          title: 'Phone',
          details: '(212) 875-5456',
        },
      ],
      objectivesHeading: 'Objective',
      objectivesDetails:
        `This project is a digital signage solution for Geffen Hall, part of Lincoln Center in NYC.
        Custom displays and a content management software was built for this project.
        Content for the screens will be partially loaded from Lincoln Center’s existing CMS via a REST API.`,
      technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'HTML',
            'CSS',
            'JavaScript',
            'Vue.js',
            'Django',
          ],
        },
      ],
      projectDetailsHeading: 'Overview',
      projectDetails: [
        {
          id: 1,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
        {
          id: 2,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        }
      ],
      socialSharingsHeading: 'Share This',
      socialSharings: [
        {
          id: 1,
          name: 'Twitter',
          icon: 'twitter',
          url: 'https://twitter.com/realstoman',
        },
        {
          id: 2,
          name: 'Instagram',
          icon: 'instagram',
          url: 'https://instagram.com/realstoman',
        },
        {
          id: 3,
          name: 'Facebook',
          icon: 'facebook',
          url: 'https://facebook.com/',
        },
        {
          id: 4,
          name: 'LinkedIn',
          icon: 'linkedin',
          url: 'https://linkedin.com/',
        },
        {
          id: 5,
          name: 'Youtube',
          icon: 'youtube',
          url: 'https://www.youtube.com/c/StomanStudio',
        },
      ],
    },
  },
  sfs: {
    singleProjectHeader: {
      singleProjectTitle: 'San Francisco Symphony',
      singleProjectDate: '2021',
      singleProjectTag: 'Installation + Web Application',
    },
    projectImages: [
      {
        id: 1,
        title: 'Kabul Project Management UI',
        type: 'video/youtube',
        img: require('@/assets/videos/sfs_1.mp4'),
      },
      // {
      //   id: 2,
      //   title: 'Kabul Project Management UI',
      //   img: require('@/assets/images/web-project-2.jpg'),
      // },
      // {
      //   id: 3,
      //   title: 'Kabul Project Management UI',
      //   img: require('@/assets/images/mobile-project-2.jpg'),
      // },
    ],
    projectInfo: {
      clientHeading: 'About Client',
      companyInfos: [
        {
          id: 1,
          title: 'Name',
          details: 'San Francisco Symphony',
        },
        {
          id: 2,
          title: 'Services',
          details: 'Concert Hall',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://www.sfsymphony.org/',
        },
        {
          id: 4,
          title: 'Phone',
          details: '(415) 864-6000',
        },
      ],
      objectivesHeading: 'Objective',
      objectivesDetails:
        'Installation for the façade and lobby of the San Francisco Symphony. The façade consists of multiple levels of programmable RGB strips and spot lights while the lobby is five dual-sided, movable totem screens.',
      technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'HTML',
            'CSS',
            'JavaScript',
            'Vue.js',
            'Django',
          ],
        },
      ],
      projectDetailsHeading: 'Overview',
      projectDetails: [
        {
          id: 1,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
        {
          id: 2,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        },
        {
          id: 3,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        },
        {
          id: 4,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
      ],
      socialSharingsHeading: 'Share This',
      socialSharings: [
        {
          id: 1,
          name: 'Twitter',
          icon: 'twitter',
          url: 'https://twitter.com/realstoman',
        },
        {
          id: 2,
          name: 'Instagram',
          icon: 'instagram',
          url: 'https://instagram.com/realstoman',
        },
        {
          id: 3,
          name: 'Facebook',
          icon: 'facebook',
          url: 'https://facebook.com/',
        },
        {
          id: 4,
          name: 'LinkedIn',
          icon: 'linkedin',
          url: 'https://linkedin.com/',
        },
        {
          id: 5,
          name: 'Youtube',
          icon: 'youtube',
          url: 'https://www.youtube.com/c/StomanStudio',
        },
      ],
    },
  },
  camden: {
    singleProjectHeader: {
      singleProjectTitle: 'Camden Battlefield',
      singleProjectDate: '2021',
      singleProjectTag: 'Installation + Mobile Application',
    },
    projectImages: [
      {
        id: 1,
        title: 'Camden Image 1',
        img: require('@/assets/videos/camden_video.mp4'),
      },      
      {
        id: 2,
        title: 'Camden Image 2',
        img: require('@/assets/images/camden.jpg'),
      },
      {
        id: 3,
        title: 'Camden Image 3',
        img: require('@/assets/images/camden_2.jpg'),
      },
      {
        id: 4,
        title: 'Camden Image 4',
        img: require('@/assets/images/camden_3.jpg'),
      },
      {
        id: 5,
        title: 'Camden Image 5',
        img: require('@/assets/images/camden_4.jpg'),
      },
    ],
    projectInfo: {
      clientHeading: 'About Client',
      companyInfos: [
        {
          id: 1,
          title: 'Name',
          details: 'Revolutionary War Visitor Center at Camden',
        },
        {
          id: 2,
          title: 'Services',
          details: 'Visitor Center',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://simplyrevolutionary.com/',
        },
        {
          id: 4,
          title: 'Phone',
          details: '(803) 272-0076',
        },
      ],
      objectivesHeading: 'Objective',
      objectivesDetails:
        'Interactive display in the visitor center at a Revolutionary War battlefield in South Carolina. Visitors use a rotary encoder to select an area on a physical map with LEDs lighting up to show the selected location while an attached 4k display will show information and images about the location. After they hit a button, the attached display will play a video about the selected location.',
      technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'HTML',
            'CSS',
            'JavaScript',
            'Vue.js',
            'Tornado',
            'Electron',
          ],
        },
      ],
      projectDetailsHeading: 'Overview',
      projectDetails: [
        {
          id: 1,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
        {
          id: 2,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        },
        {
          id: 3,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        },
        {
          id: 4,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
      ],
      socialSharingsHeading: 'Share This',
      socialSharings: [
        {
          id: 1,
          name: 'Twitter',
          icon: 'twitter',
          url: 'https://twitter.com/realstoman',
        },
        {
          id: 2,
          name: 'Instagram',
          icon: 'instagram',
          url: 'https://instagram.com/realstoman',
        },
        {
          id: 3,
          name: 'Facebook',
          icon: 'facebook',
          url: 'https://facebook.com/',
        },
        {
          id: 4,
          name: 'LinkedIn',
          icon: 'linkedin',
          url: 'https://linkedin.com/',
        },
        {
          id: 5,
          name: 'Youtube',
          icon: 'youtube',
          url: 'https://www.youtube.com/c/StomanStudio',
        },
      ],
    },
  },
  mta: {
    singleProjectHeader: {
      singleProjectTitle: 'Camden Battlefield',
      singleProjectDate: '2021',
      singleProjectTag: 'Installation + Mobile Application',
    },
    projectImages: [   
      {
        id: 1,
        title: 'MTA 2',
        img: require('@/assets/images/mta_1.jpeg'),
      },
      {
        id: 2,
        title: 'MTA 3',
        img: require('@/assets/images/mta_2.jpeg'),
      },
      {
        id: 3,
        title: 'MTA 4',
        img: require('@/assets/images/mta_3.jpeg'),
      },
      {
        id: 4,
        title: 'MTA Image 5',
        img: require('@/assets/images/mta_4.jpeg'),
      },
    ],
    projectInfo: {
      clientHeading: 'About Client',
      companyInfos: [
        {
          id: 1,
          title: 'Name',
          details: 'The Metropolitan Transportation Authority',
        },
        {
          id: 2,
          title: 'Services',
          details: 'Public transportation',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://new.mta.info/',
        },
      ],
      objectivesHeading: 'Objective',
      objectivesDetails:
        'Stylized map showing real-time location of LIRR trains. The display application required to be vanilla JavaScript (no frameworks) and load JSON from the server to then update the DOM at specific wall times (:00, :15, :30, :45). It uses the data it loads to manipulate the SVG of the map - creating some elements and simply changing the color of others.',
      technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'HTML',
            'SVG',
            'CSS',
            'JavaScript',
            'Python',
            'OutFront digital sign in HD portrait (1080 x 1920).'
          ],
        },
      ],
      projectDetailsHeading: 'Overview',
      projectDetails: [
        {
          id: 1,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
        {
          id: 2,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        },
        {
          id: 3,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?',
        },
        {
          id: 4,
          details:
            'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Incidunt totam dolorum, ducimus obcaecati, voluptas facilis molestias nobis ut quam natus similique inventore excepturi optio ipsa deleniti fugit illo. Unde, amet! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum illo necessitatibus perspiciatis! Aperiam perferendis labore temporibus, eos culpa corporis recusandae quas, fuga voluptatibus nesciunt odit libero tenetur neque consequatur ea.',
        },
      ],
      socialSharingsHeading: 'Share This',
      socialSharings: [
        {
          id: 1,
          name: 'Twitter',
          icon: 'twitter',
          url: 'https://twitter.com/realstoman',
        },
        {
          id: 2,
          name: 'Instagram',
          icon: 'instagram',
          url: 'https://instagram.com/realstoman',
        },
        {
          id: 3,
          name: 'Facebook',
          icon: 'facebook',
          url: 'https://facebook.com/',
        },
        {
          id: 4,
          name: 'LinkedIn',
          icon: 'linkedin',
          url: 'https://linkedin.com/',
        },
        {
          id: 5,
          name: 'Youtube',
          icon: 'youtube',
          url: 'https://www.youtube.com/c/StomanStudio',
        },
      ],
    },
  },
};